import React from 'react'
import { Grid, Icon, Image } from 'semantic-ui-react';
import Labels from './../../../../common/Labels';
import momentDateAndTime from './../../../../../helpers/momentDateAndTime'
import noImage from './../../../../../images/common/broken-image.png'
var moment = require('moment');

class Summary extends React.Component {

    addDefaultSrc = (ev) => {
        ev.target.src = noImage
    }

    render() {
        let practiceData = this.props.selectedDataById;


        return (
            <Grid  >
                <Grid.Row>
                    <Grid.Column width={5}>
                        <Image onError={this.addDefaultSrc} src={practiceData && practiceData.picture} className="fitImage" alt={practiceData.name} />
                    </Grid.Column>
                    <Grid.Column width={1}></Grid.Column>
                    <Grid.Column width={6}>
                        <Labels
                            name="Overview"
                            text={
                                <span>
                                    <div style={{ 'margin': '5px 0' }}>
                                        <Icon name="sitemap" color="grey" />
                                        <span className="ui blue circular label cardLabel">
                                            {practiceData && practiceData.countList && practiceData.countList.activityCount}
                                        </span>
                                        <span> Activities</span>
                                    </div>
                                    <div style={{ 'margin': '5px 0' }}>
                                        <Icon name="copy" color="grey" />
                                        <span className="ui blue circular label cardLabel">
                                            {practiceData.totalIntances}
                                        </span>
                                        <span> Usage Count</span>
                                    </div>
                                    <div style={{ 'margin': '5px 0' }}>
                                        <Icon name="thumbs up" color="grey" />
                                        <span className="ui blue circular label cardLabel"> 0</span>
                                        <span> Likes / Thumbs-Up</span>
                                    </div>
                                </span>
                            }
                        />
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <Labels
                            name="Published On"
                            text={practiceData ? momentDateAndTime(practiceData.createdAt) : momentDateAndTime()}
                        />

                        <Labels
                            name="Current Version"
                            text={practiceData && practiceData.version}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }
}

export default Summary